module.exports = __webpack_public_path__ + "static/media/grataCanisMajorEmail.c8ae4510.jpg";